import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { IndicadoresAtividadeService } from "../services/indicadores-atividade.service";

@Injectable({
  providedIn: 'root'
})
export class IndicadoresAtividadeResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresAtividadeService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresAtividadeSimplificadoResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresAtividadeService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdSimple(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresAtividadeListResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresAtividadeService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdList();
  }
}